module.exports = __webpack_public_path__ + "static/media/NNL-SS1.40dbac28.jpg";